<div class="st-modal">
  <!-- Header -->
  <div class="st-header">
    <div class="st-title">{{ 'TransferStock' | localize }}</div>
    <div class="st-close" (click)="onNoClick()" attr.aria-label="{{ 'Cancel' | localize }}">×</div>
  </div>

  <form [formGroup]="fgRefer" (ngSubmit)="save()" class="st-body">

    <!-- Origen → Destino: el label vive dentro del mat-form-field (mat-label),
         así cada columna es un solo bloque y la flecha queda centrada
         exactamente con el select, sin importar el ancho de pantalla. -->
    <div class="st-warehouses">
      <div class="st-wh-col">
        <mat-form-field appearance="outline" class="st-select">
          <mat-label>{{ 'OriginWarehouse' | localize }}</mat-label>
          <mat-select formControlName="warehouseFromId" required>
            <mat-option *ngFor="let item of warehouses" [value]="item.id">{{ item.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="st-arrow-col">
        <div class="st-arrow">→</div>
      </div>

      <div class="st-wh-col">
        <mat-form-field appearance="outline" class="st-select">
          <mat-label>{{ 'DestinationWarehouse' | localize }}</mat-label>
          <mat-select formControlName="warehouseToId" required>
            <mat-option *ngFor="let item of warehouses" [value]="item.id"
              [disabled]="fgRefer.get('warehouseFromId').value == item.id">{{ item.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Descripción -->
    <div class="st-field st-desc">
      <label class="st-label">{{ 'Description' | localize }}</label>
      <textarea formControlName="description" rows="2" maxlength="64" placeholder="{{ 'TransferReason' | localize }}"
        class="st-textarea"></textarea>
      <div class="st-counter" [class.st-counter--warn]="descriptionInvalid">{{ descriptionLength }}/64</div>
    </div>

    <!-- Buscar productos -->
    <div class="st-field">
      <label class="st-label">{{ 'SearchProducts' | localize }}</label>
      <app-search-products [input]="'productInput'" [showSplitName]="true" [addQuantity]="false"
        [showStockQuantity]="true" (newData)="searchProductsFromComponent($event)"></app-search-products>
    </div>

    <!-- Estado vacío -->
    <div class="st-empty" *ngIf="productsArr.length == 0">
      {{ 'EmptyProducts' | localize }}
    </div>

    <!-- Lista de productos -->
    <div class="st-list" *ngIf="productsArr.length > 0" formArrayName="listProducts">
      <div class="st-list-head">
        <div class="st-col-product">{{ 'Products' | localize }}</div>
        <div class="st-col-qty">{{ 'Quantity' | localize }}</div>
        <div class="st-col-actions"></div>
      </div>

      <div class="st-rows">
        <div class="st-row" *ngFor="let item of productsArr.controls; let i = index" [formGroupName]="i">
          <div class="st-col-product">
            <div class="st-prod-name">{{ item.value.name }}</div>
            <div class="st-overstock" *ngIf="isOverStock(item)">
              ⚠ {{ 'ExceedsAvailableStock' | localize }} ({{ item.value.stock }})
            </div>
          </div>

          <div class="st-col-qty">
            <div class="st-stepper">
              <div class="st-step-btn" (click)="decQty(i)">–</div>
              <input type="number" formControlName="count" min="1" class="st-qty-input">
              <div class="st-step-btn" (click)="incQty(i)">+</div>
            </div>
          </div>

          <div class="st-col-actions">
            <span class="st-remove" (click)="deleteProduct(i)" matTooltip="{{ 'Delete' | localize }}"
              attr.aria-label="{{ 'Delete' | localize }}">🗑</span>
          </div>
        </div>
      </div>

      <!-- Misma grilla de columnas que el header/filas (Producto/Cantidad/Acciones),
           así el total queda exactamente debajo de "Cantidad", no pegado al borde. -->
      <div class="st-total">
        <div class="st-col-product">{{ 'Total' | localize }}</div>
        <div class="st-col-qty">{{ getTotal() }}</div>
        <div class="st-col-actions"></div>
      </div>
    </div>
  </form>

  <!-- Acciones -->
  <div class="st-actions">
    <button mat-button type="button" (click)="onNoClick()">{{ 'Cancel' | localize }}</button>
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="fgRefer.invalid || saving">{{
      'Save' | localize }}</button>
  </div>
</div>